<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="button-container">
          <el-button
            :disabled="isLoading"
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="handleCreate"
          >
            {{ $t('button.create') }}
          </el-button>
        </div>
        <el-button
          :disabled="isLoading"
          class="save-button"
          size="mini"
          type="success"
          icon="el-icon-upload2"
          @click="handleSave"
        >
          {{ $t('button.save') }}
        </el-button>
      </div>
    </template>
    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%"
      row-key="id"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        width="50"
      /> -->
      <el-table-column prop="name" label="Name" width="300">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.name"
            clearable
          />
         </template>
      </el-table-column>
      <el-table-column prop="icon" label="Icon">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.icon"
            clearable
          />
         </template>
      </el-table-column>
      <el-table-column
        label="Action"
        align="center"
        width="120"
      >
        <template slot-scope="{ row, $index }">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(row)"
          />
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDelete($index)"
          />
        </template>
      </el-table-column>
      <!-- Drag Button -->
      <el-table-column
        align="center"
        label="Drag"
        width="55"
      >
        <span class="drag-handler mt-1">
          <font-awesome-icon
            class="drag"
            icon="arrows-alt"
          />
        </span>
      </el-table-column>
      <!-- Drag Button -->
    </el-table>
    
  </sticky-header-layout>
</template>

<script>
import Sortable from 'sortablejs'
import HomeConfigsAPI from '../../api/home-configs'
import { getRandomHash } from '../../utils/helper'

export default {
  name: 'InstoryList',
  data() {
    return {
      sortableObject: null,
      list: [],
      isLoading: true,
    }
  },
  computed: {
    canSave() {
      return !this.loading
    },
  },
  mounted() {
    this.getList()
    this.$nextTick(() => {
      this.setSort()
    })
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await HomeConfigsAPI.getInstoryList()
        const { data } = response
        // const { rows } = data
        if (Array.isArray(data)) {
          this.list = data
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    handleCreate() {
      const item = {
        id: getRandomHash(),
        name: '',
        icon: '',
        new: true, // This is very important for api to determine where it should create or update.
      }
      this.list.push(item)

      this.$nextTick(() => {
        this.setSort()
      })
    },
    async handleSave() {
      if (!this.validateFormItems(this.list)) {
        this.$message({
          message: 'Please fill in all data.',
          type: 'error',
        });
        return
      }

      this.isLoading = true
      try {
        await HomeConfigsAPI.updateInstories(this.list)
        await this.getList()
        this.$message({
          message: 'Saved',
          type: 'success',
        });
        console.log(this.list)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    handleUpdate(row) {
      this.$router.push({ path: `/home-configs/instory-items/${row.id}` })
    },
    handleDelete(index) {
      this.$confirm(`Confirm Delete?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list.splice(index, 1)
      }).catch(() => {
      })
    },
    setSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      if (!el) return
      this.sortableObject = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        handle: '.drag-handler',
        setData(dataTransfer) {
          dataTransfer.setData('Text', '')
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
        },
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt
          // console.log(oldIndex, newIndex)
          const targetRow = this.list.splice(oldIndex, 1)[0]
          this.list.splice(newIndex, 0, targetRow)
          console.log(this.list)
          // this.handleUpdateItemOrder({ oldIndex, newIndex })
          // this.$emit('updateOrder', { oldIndex, newIndex })
        },
      })
    },
    validateFormItems(list) {
      for (let i = 0; i < list.length; i += 1) {
        const item = list[i]
        const hasValidInput = !!item.name || item.icon
        if (!hasValidInput) {
          return false
        }
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>

